import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Text } from '../../ui/Text';
import { StyledKey, StyledWrapper } from './Shortcut.style';
export const Shortcut = ({ value }) => {
    const keys = useMemo(() => {
        const isMac = navigator.userAgent.indexOf('Macintosh') >= 0;
        if (isMac) {
            return value
                .replace('Ctrl', '⌘')
                .replace('Alt', '⌥')
                .replace('Shift', '⇧')
                .split('+');
        }
        return value.split('+');
    }, [value]);
    return null;
    return (_jsx(StyledWrapper, { children: keys.map((key) => (_jsx(StyledKey, { children: _jsx(Text, { size: 'Small', children: key }) }, key))) }));
};
//# sourceMappingURL=Shortcut.js.map